import CancelIcon from "@mui/icons-material/Cancel";
import Modal from "@mui/material/Modal";
import ErrorBoundary from "../../ErrorBoundary";

interface ConfirmModalProps {
  isImageModalOpen: boolean;
  handleImageModalClose: () => void;
  joNo: string;
  status: string;
  image: string;
  remarks: string;
}

function ImageModal({
  isImageModalOpen,
  handleImageModalClose,
  joNo,
  status,
  image,
  remarks,
}: ConfirmModalProps) {
  return (
    <ErrorBoundary>
      <Modal
        open={isImageModalOpen}
        onClose={handleImageModalClose}
        hideBackdrop
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="backdrop-blur-sm backdrop-brightness-50"
      >
        <div className="absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 bg-white border-2 border-black rounded-md shadow-xl max-h-[90vh] overflow-y-auto p-2 min-w-[90%] md:min-w-0 max-w-full">
          <div className="flex justify-between">
            <span className="font-bold my-auto px-3 py-2">
              <span className="text-nowrap">{`JO No : ${joNo},`}</span>{" "}
              <span className="text-nowrap"> {`Status : ${status}`}</span>
              <br />
              <span> {`Remarks : ${remarks}`}</span>
            </span>
            <span
              className="cursor-pointer text-red-700 font-extrabold mt-2"
              onClick={handleImageModalClose}
            >
              <CancelIcon />
            </span>
          </div>
          <div className="px-8">
            <img
              src={image}
              alt="status"
              className="max-w-full max-h-[200vh] object-contain mx-auto"
            />
          </div>
        </div>
      </Modal>
    </ErrorBoundary>
  );
}

export default ImageModal;
